/**
 * How the activation page presents itself for the caller: forms lock without account update rights
 * (as for an already-submitted account), and an operator — who may update but not submit — keeps the
 * "continue filling" CTA but never sees the submit CTA.
 */
export function resolveActivationGates(params: {
  isActivationLocked: boolean;
  isTrustActive: boolean;
  canSendPackages: boolean;
  canUpdateAccount: boolean;
  canSubmitForReview: boolean;
}): {isLocked: boolean; showsGlobalCta: boolean} {
  const {isActivationLocked, isTrustActive, canSendPackages, canUpdateAccount, canSubmitForReview} =
    params;
  const isLocked = isActivationLocked || !canUpdateAccount;

  return {
    isLocked,
    showsGlobalCta: isTrustActive || (!isLocked && (canSubmitForReview || !canSendPackages))
  };
}

/**
 * The compliance form's declarations lock without the right to sign, independently of its
 * documents, which follow the package's own read-only state.
 */
export function isComplianceFormReadOnly(params: {
  readOnly: boolean;
  canSignDeclarations: boolean;
}): boolean {
  return params.readOnly || !params.canSignDeclarations;
}
